import React from 'react';

import { GroupRecommendationSkeleton } from './components/GroupRecommendationSkeleton';

/**
 * Wrapper component that renders multiple group recommendation skeletons.
 * Used when loading group recommendations to provide visual feedback.
 *
 * ```tsx
 * <GroupRecommendationLoadingSkeleton count={3} />
 * ```
 */
export const GroupRecommendationLoadingSkeleton: React.FC<Props> = ({ count = 3 }) => {
	return (
		<div className="flex flex-row gap-4" data-testid="recommendations-loading-skeleton">
			{Array.from({ length: count }, (_, index) => (
				<GroupRecommendationSkeleton key={index} />
			))}
		</div>
	);
};

type Props = Readonly<{
	/** Number of skeleton cards to render. Defaults to 3. */
	count?: number;
}>;
